/*------------------------------------*\
	#MODAL
\*------------------------------------*/

import 'a11y-dialog';

const initModal = () => {
	const modals = document.querySelectorAll('.c-dialog');
	const footer = document.querySelector('.c-footer');
	modals.forEach(modal => {
		footer.insertAdjacentElement('afterend', modal);
	})
}

window.addEventListener('DOMContentLoaded', (event) => {
	initModal();
});
